export const DANGER_MATRIX = {
  low: { other: 'low', grass: 'low', crop: 'low', scrub: 'low', wood: 'low' },
  moderate: { other: 'elevated', grass: 'elevated', crop: 'elevated', scrub: 'high', wood: 'high' },
  high: { other: 'elevated', grass: 'high', crop: 'high', scrub: 'high', wood: 'high' },
};